import { TokenImpersonationModal } from "src/adminPanel/users/TokenImpersonationModal";
import {
  useAccessibleOrganizations,
  useNavigableWorkspaces,
} from "src/api/queries";

/**
 * Self-contained entry point for the token impersonation modal, for callers
 * outside the admin panel (e.g. the omnibox). The session token there is
 * scoped to the current workspace, which narrows GET /organizations and
 * GET /workspaces — so this resolves reach names through the two endpoints
 * that expand the caller's full, unscoped role set instead:
 * /organizations/me/accessible-orgs and /workspaces/navigable.
 */
export const TokenImpersonationLauncher: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  const organizations = useAccessibleOrganizations({ enabled: isOpen });
  const workspaces = useNavigableWorkspaces({ enabled: isOpen });

  return (
    <TokenImpersonationModal
      isOpen={isOpen}
      organizations={organizations.data ?? []}
      workspaces={workspaces.data ?? []}
      onClose={onClose}
    />
  );
};
